import {BaseModel} from "@/model/Model";
import User from "@/model/User";
import Book from "@/model/Book";

export default class Location extends BaseModel<Location> {
   province!: string
    city!: string
    area!: string
    address!: string
}
